// extracted by mini-css-extract-plugin
module.exports = {"root":"_93444fe79c--root--3I0W5","header":"_93444fe79c--header--dWchK","icon":"_93444fe79c--icon--1DmSz"};